module.exports = __webpack_public_path__ + "img/notify-hp.dfb5c66d.jpg";